module.exports = __webpack_public_path__ + "img/selected7-min.517aa789.png";